<script lang="ts" setup>
import AddressFields from '@/components/common/AddressFields.vue';
import { Address, defaultAddress } from '@/models/info.model';
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object as PropType<Address>,
    required: true,
  },
  disabled: {
    type: Boolean,
  },
});

const address = ref<Address>({ ...props.modelValue });

const emit = defineEmits(['update:modelValue', 'change']);

function update(v: Address) {
  emit('update:modelValue', {
    ...v,
    alternative: [...(address.value.alternative || [])],
  });
  emit('change', {
    ...v,
    alternative: [...(address.value.alternative || [])],
  });
}

watch(
  () => props.modelValue,
  () => {
    address.value = { ...props.modelValue };
  },
);

function updateAlternative(v: Address, index: number) {
  const alternative = [...(address.value.alternative || [])];
  alternative.splice(index, 1, v);

  Object.assign(address.value, {
    ...address.value,
    alternative,
  });

  update(address.value);
}

function addAdress() {
  Object.assign(address.value, {
    ...address.value,
    alternative: [...(address.value.alternative || []), { ...defaultAddress }],
  });
}

function removeAddress(index: number) {
  const alternative = [...(address.value.alternative || [])];
  alternative.splice(index, 1);

  Object.assign(address.value, {
    ...address.value,
    alternative,
  });
}
</script>
<template>
  <h3>
    {{
      $t('initiative.edit.addresses', {
        count: 1 + (address.alternative?.length || 0),
      })
    }}
  </h3>
  <AddressFields
    v-model="address"
    @update:model-value="update"
    :disabled="disabled"
  />
  <AddressFields
    v-for="(a, index) in address.alternative || []"
    :label="`Alternative ${index + 1}`"
    removable
    @remove="removeAddress(index)"
    :key="index"
    :disabled="disabled"
    v-model="(address.alternative || [])[index]"
    @update:model-value="(v) => updateAlternative(v, index)"
  />

  <v-btn v-if="!disabled" @click="addAdress">{{
    $t('initiative.edit.addAddress')
  }}</v-btn>
  <br />
  <br />
</template>
